<template>
  <div>
    <div class="question-detail">
      <el-row :gutter="20"
              style="width: 100%;">
        <!-- 说明文本 -->
        <el-col :xl="span.xl"
                :md="span.md"
                :xs="span.xs">
          <el-popover
              placement="right-start"
              trigger="click"
              :disabled="question.text.length === 0">
            <div v-html="question.text"></div>
            <div class="question-detail-text"
                 slot="reference"
                 v-perfect-scrollbar.relative="{wheelPropagation:true}">
              <span class="question-detail-title">说明信息：</span>
              <span>{{question.text | getText}}</span>
            </div>
          </el-popover>
        </el-col>
        <!-- 说明图片 -->
        <el-col :xl="span.xl"
                :md="span.md"
                :xs="span.xs">
          <div class="question-detail-img"
               v-perfect-scrollbar.relative="{wheelPropagation:true}">
            <ul>
              <li
                v-for="({src}, index) in question.images"
                :key="src"
                @click="onViewImage(index, question.images)">
                <img :src="src|ossHost(imgUrlSuffix)"
                     alt="">
              </li>
            </ul>
          </div>
        </el-col>
        <!-- 示例文本 -->
        <el-col v-if="showExample && question.hasOwnProperty('exampleText')"
                :xl="span.xl"
                :md="span.md"
                :xs="span.xs">
          <el-popover
              placement="right-start"
              trigger="click"
              :disabled="question.exampleText.length === 0">
            <div v-html="question.exampleText"></div>
            <div class="question-detail-text"
                 slot="reference"
                 v-perfect-scrollbar.relative="{wheelPropagation:true}">
              <span class="question-detail-title">示例信息：</span>
              <span>{{question.exampleText | getText}}</span>
            </div>
          </el-popover>
        </el-col>
        <!-- 示例图片 -->
        <el-col v-if="showExample && question.hasOwnProperty('exampleImages')"
                :xl="span.xl"
                :md="span.md"
                :xs="span.xs">
          <div class="question-detail-img"
               v-perfect-scrollbar.relative="{wheelPropagation:true}">
            <ul>
              <li
                v-for="({src}, index) in question.exampleImages"
                :key="src"
                @click="onViewImage(index, question.exampleImages)">
                <img :src="src|ossHost(imgUrlSuffix)"
                     alt="">
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import AnswerFileFullScreen from '../../components/AnswerFileFullScreen'

export default {
  components: {},
  mixins: [],
  props: {
    question: Object,
    questionIndex: Number,
    showExample: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      imgUrlSuffix: '?x-oss-process=image/resize,m_pad,h_90,w_90,color_FFFFFF',
    }
  },
  computed: {
    span () {
      let span1 = {
        xl: 6,
        md: 12,
        xs: 24,
      }
      let span2 = {
        xl: 12,
        md: 12,
        xs: 24,
      }
      if (this.question.exampleText && this.question.exampleImages) {
        return span1
      }
      return span2
    },
  },
  watch: {},
  beforeCreate () {},
  created () {
    this.$nextTick(() => {})
  },
  mounted () {},
  methods: {
    onViewImage (index, files) {
      AnswerFileFullScreen({
        question: this.question,
        questionIndex: this.questionIndex,
        files: files,
        viewIndex: index,
        type: 'photo',
        toolbar: {delete: false},
      })
    },
  },
  filters: {
    getText: function (value) {
      if (!value) return ''
      return $('<div>' + value + '</div>').text()
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/packages/QuestionDetail/index.vue